// extracted by mini-css-extract-plugin
var _1 = "PreviewAbsolute_root__e3964";
export { _1 as "root" }
